import { getFormatDate } from "../shared/utils/dateUtilities";

export const dateToRelativeFormat = (date: string) => {
  const diff: number = new Date(date) - new Date();

  const seconds = diff / 1000;
  const minutes = seconds / 60;
  const hours = minutes / 60;
  const days = Math.round(hours / 24);

  if (days < -7) {
    return getFormatDate(date);
  }

  const formatter = new Intl.RelativeTimeFormat("es-ES", {
    numeric: "auto",
  });

  return formatter.format(days, "days");
};
